import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import { LocalizedDatePipe } from '../../shared/pipes/localized-date.pipe'

@Component({
  selector: 'dhp-magazine',
  templateUrl: './magazine.component.html',
  styleUrl: './magazine.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslatePipe, LocalizedDatePipe],
})
export class MagazineComponent {
  readonly title = input.required<string>()
  readonly imageUrl = input.required<string>()
  readonly id = input.required<number>()
  readonly slug = input.required<string>()
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() year?: number
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() edition?: string
  readonly editionId = input<number>()
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() publicationDate?: Date
  readonly selectionAndEssence = input<boolean>()

  getRouterLink(): (string | number)[] {
    // Selection & Essence magazines
    if (this.selectionAndEssence() === true) {
      return ['/magazines/selection-essence/detail', this.id(), this.slug()]
    }

    // Regular magazines with edition
    const editionId = this.editionId()
    if (editionId) {
      return ['/magazines/detail', this.id(), this.slug(), 'edition', editionId]
    }

    // Regular magazines without edition
    return ['/magazines/detail', this.id(), this.slug()]
  }
}
